import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface StopFieldsProps extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean;
}

export default function StopFields({ isSelected = false, style, onClick }: StopFieldsProps) {
  return (
    <SvgIcon onClick={onClick} viewBox="0 0 26 26" style={{ width: `24px`, height: `24px`, ...(style ?? {}) }}>
      <g>
        {!isSelected ? (
          <g>
            <path
              fill={RoutalPalette.neutral60}
              d="m13,1.5c6.34,0,11.5,5.16,11.5,11.5s-5.16,11.5-11.5,11.5S1.5,19.34,1.5,13,6.66,1.5,13,1.5m0-1C6.1.5.5,6.1.5,13s5.6,12.5,12.5,12.5,12.5-5.6,12.5-12.5S19.9.5,13,.5h0Z"
            />
            <g>
              <path
                fill={RoutalPalette.neutral60}
                d="m13,19.5c-.28,0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5s.5.22.5.5v9c0,.28-.22.5-.5.5Z"
              />
              <circle fill={RoutalPalette.neutral60} cx="13" cy="7.25" r=".75" />
            </g>
          </g>
        ) : (
          <g>
            <circle fill={RoutalPalette.primary40} cx="13" cy="13" r="12.5" />
            <g>
              <path
                fill={RoutalPalette.neutral00}
                d="m13,19.5c-.28,0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5s.5.22.5.5v9c0,.28-.22.5-.5.5Z"
              />
              <circle fill={RoutalPalette.neutral00} cx="13" cy="7.25" r=".75" />
            </g>
          </g>
        )}
      </g>
    </SvgIcon>
  );
}
